import { useMemo } from 'react'
import { Alert, Stack } from '@mui/material'
import dayjs from 'dayjs'
import { doyToJSDate } from '~/common/utils/doy-utils'

/**
 * Renders conditional warning alerts for the End Season modal.
 * Returns null if there are no warnings.
 *
 * @param {Object[]} tasks - All org tasks (from useTasksInOrg)
 * @param {Object|null} climateData - Climate data with avg_ffd (DOY)
 */
export const SeasonWarningsBanner = ({ tasks, climateData }) => {
  const uncompletedCount = useMemo(
    () => tasks.filter(t => t.state !== 'completed' && t.state !== 'cancelled').length,
    [tasks]
  )

  const isBeforeFfd = useMemo(() => {
    if (!climateData?.avg_ffd) return false
    const ffd = doyToJSDate(climateData.avg_ffd)
    return dayjs().isBefore(dayjs(ffd), 'day')
  }, [climateData])

  if (!uncompletedCount && !isBeforeFfd) return null

  return (
    <Stack spacing={0.75} sx={{ mt: '0.75rem' }}>
      {uncompletedCount > 0 && (
        <Alert severity="warning" sx={{ py: 0.5 }}>
          {uncompletedCount} task{uncompletedCount !== 1 ? 's' : ''} still uncompleted — ending the season will archive them as-is.
        </Alert>
      )}
      {isBeforeFfd && (
        <Alert severity="info" sx={{ py: 0.5 }}>
          You are ending the season before the first fall frost date ({dayjs(doyToJSDate(climateData.avg_ffd)).format('MMM D')}). Some crops may still be active.
        </Alert>
      )}
    </Stack>
  )
}
